import axios from 'axios';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import type { UserRegistrationData } from './model';
import type { RegistrationResultDto } from './dto';
import { mapModelToDto } from './mapper';

export async function createUser(
  userRegistrationData: UserRegistrationData,
): Promise<RegistrationResultDto> {
  const response = await axios.post<ApiBaseResponse & RegistrationResultDto>(
    '/api/v1/registration',
    mapModelToDto(userRegistrationData),
  );

  if (!response.data.success) throw new Error('Failed to register');

  return response.data;
}
